import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function getCustomList(params) {
  return request({
    url: `${v2Host}/dmaker/custom-dist/list`,
    method: 'GET',
    params: cookRequestParams(params)
  })
}
